export default function unitEmptyValue() {
    return {
        forms: [],
    }
}
